import React, { memo } from 'react';
import PropTypes from 'prop-types';
import {
  Card,
} from 'reactstrap';
import { useTranslation } from 'react-i18next';

import AppAvatar from 'components/App/Avatar';
import AppButton from 'components/App/Button';

import { ReactComponent as At } from 'assets/images/At.svg';
import { ReactComponent as Phone } from 'assets/images/Phone.svg';
import { ReactComponent as Language } from 'assets/images/Language.svg';
import { ReactComponent as Gender } from 'assets/images/Gender.svg';
import { LANGUAGE_LABEL } from 'constants/setting';

function CardLocationContactInfo(props) {
  const {
    list,

    placeId,

    setModalType,
    onOpenModal,
    onOpenModalViewContactInfo,
    actionGetPlaceContactDetails,
  } = props;

  const { t } = useTranslation();

  const onClickEditContactInfo = React.useCallback((e) => {
    e.stopPropagation();
    setModalType('EDIT');
    onOpenModal();
    actionGetPlaceContactDetails({ id: list._id, place: placeId });
  }, [actionGetPlaceContactDetails, list._id, onOpenModal, placeId, setModalType]);

  const onClickViewContactInfo = React.useCallback(() => {
    actionGetPlaceContactDetails({ id: list._id, place: placeId });
    onOpenModalViewContactInfo();
  }, [actionGetPlaceContactDetails, list._id, onOpenModalViewContactInfo, placeId]);

  return (
    <Card className="Section__Card Border" onClick={onClickViewContactInfo}>
      <div className="Section__Card__Header">
        <div className="BoxAvatar">
          <AppAvatar
            className="avatar-select"
            name={list.name}
            alt={list.name}
          />

          <div className="Text">
            <div className="Text__Title">
              {list.name}
            </div>

            <div className="Text__Subtitle">
              {t(`global.place_contact_roles.${list.role}`)}
            </div>
          </div>
        </div>

        <AppButton
          isDefault
          classes="Button"
          onClick={onClickEditContactInfo}
        >
          Chỉnh sửa
        </AppButton>
      </div>

      <hr className="Line" />

      <div className="SocialGroup">
        <At />

        <p className="Text">{list.email}</p>
      </div>

      {list.phoneNumbers && list.phoneNumbers.map((item) => (
        <div className="SocialGroup" key={item}>
          <Phone />

          <p className="Text">{item}</p>
        </div>
      ))}

      <div className="SocialGroup">
        <Language />

        <p className="Text">{LANGUAGE_LABEL[list.mainLanguage]}</p>
      </div>

      <div className="SocialGroup">
        <Gender />

        <p className="Text">{t(`global.genders.${list.gender}`)}</p>
      </div>
    </Card>
  );
}

CardLocationContactInfo.propTypes = {
  list: PropTypes.instanceOf(Object),

  placeId: PropTypes.string.isRequired,

  setModalType: PropTypes.func.isRequired,
  onOpenModal: PropTypes.func.isRequired,
  onOpenModalViewContactInfo: PropTypes.func.isRequired,
  actionGetPlaceContactDetails: PropTypes.func.isRequired,
};

CardLocationContactInfo.defaultProps = {
  list: {},
};

export default memo(CardLocationContactInfo);
